<ng-template #formFields>
    <div class="flex flex-col gap-4">
        <div>
            <label class="block font-semibold mb-1">{{"Project name"}} <span class="text-danger">*</span></label>
            <input pInputText class="w-full border rounded-base p-1 border-gray-300" [(ngModel)]="projectFormData.name"
                name="name" [style]="{ outline: 'none' }" required />
        </div>
        <div>
            <label class="block font-semibold mb-1">{{"Project ID"}} <span class="text-danger">*</span></label>
            <input pInputText class="w-full border rounded-base p-1 border-gray-300"
                [(ngModel)]="projectFormData.projectId" name="projectId" [style]="{ outline: 'none' }" required />
        </div>
        <div>
            <label class="block font-semibold mb-1">{{"Project admins"}}</label>
            <app-multi-select [options]="managerOptions" [(value)]="projectManagers"
                [config]="{filter: true, placeholder: 'Select admins', style: {width: '100%'}, styleClass: 'border', appendTo: 'body'}"
                optionLabel="label" optionValue="value" [itemTemplate]="itemTemplate">
                <ng-template #itemTemplate let-manager>
                    <div class="flex items-center gap-2">
                        <p-avatar [image]="manager | userAvatar" class="header-avatar h-5 w-5" shape="circle"
                            size="normal" class="h-5 mr-1" />
                        <span>{{manager.label}}</span>
                    </div>
                </ng-template>
            </app-multi-select>
        </div>
        <div>
            <label class="block font-semibold mb-1">{{"Customer / prospect name"}} <span
                    *ngIf="!projectFormData.internal" class="text-danger">*</span></label>
            <input pInputText class="w-full border rounded-base p-1 border-gray-300"
                [(ngModel)]="projectFormData.customer" name="customer" [style]="{ outline: 'none' }" />
        </div>
        <div class="max-w-[40%]">
            <label class="block font-semibold mb-1">{{"Due date"}}</label>
            <app-datepicker [(value)]="projectDueDate" [config]="{
                    minDate: minimumDate,
                    dateFormat: 'dd MM yy',
                    showIcon: true,
                    appendTo: 'body'
                }" />
        </div>
        @if(mode === 'create') {
        <div>
            <label class="block font-semibold mb-1">
                <div class="flex items-center gap-2">
                    <div>Project knowledge
                    </div>
                    <span [pTooltip]="'Project-specific centralized repository'" tooltipPosition="top" appendTo="body"
                        class="cursor-pointer flex items-center">
                        <app-icon [type]="'info'" source="lucide" size="sm"></app-icon>
                    </span>
                </div>

            </label>
            <div class="flex items-center justify-between gap-2">
                <app-button variant="outlined" severity="contrast" label="Upload" icon="pi pi-upload"
                    (clicked)="openProjectKnowledgeDialog()" [enableThrottle]="true">
                </app-button>
                @if(getProjectKnowledgeFileCount() > 0) {
                <span class="text-sm bg-green-100 px-2 py-1 rounded-md text-green-500 font-medium">
                    {{ getProjectKnowledgeFileCount() }} {{ getProjectKnowledgeFileCount() === 1 ? 'file' : 'files' }}
                    uploaded
                </span>
                }
            </div>
        </div>
        }
        <div class="flex items-center gap-2 mt-2">
            <app-checkbox [(value)]="projectFormData.internal"
                [config]="{ binary: true, label: 'It\'s not for everyone, I\'m just testing things internally.', labelStyleClass: 'italic text-gray-600 text-sm' }">
            </app-checkbox>
        </div>


        @if(mode === 'create' && projectTagsTypes.length > 0) {
        <div class="flex flex-col gap-2">
            @for(tagType of projectTagsTypes; track tagType._id) {
            <ng-container *ngTemplateOutlet="tagFieldTemplate; context: {
                        tagType: tagType,
                        value: getTagValue(tagType._id || ''),
                        isNew: false
                    }"></ng-container>
            }
        </div>
        }

        @if(mode === 'edit' && projectTags.length > 0) {
        <div class="flex flex-col gap-2">
            @for(tag of projectTags; track tag.tagType._id) {
            <ng-container *ngTemplateOutlet="tagFieldTemplate; context: {
                        tagType: tag.tagType,
                        value: tag.isNew ? getTagValue(tag.tagType._id || '') : (tag.tagType.dataType === TAG_DATA_TYPES.DROPDOWN ? getEditModeValue(tag) : tag.value),
                        isNew: tag.isNew || false
                    }"></ng-container>
            }
        </div>
        }
    </div>
</ng-template>

<!-- Reusable tag field template -->
<ng-template #tagFieldTemplate let-tagType="tagType" let-value="value" let-isNew="isNew">
    <div>
        <label class="block font-semibold mb-1">{{tagType.name}}<span *ngIf="tagType.mandatory" class="text-danger">
                *</span></label>

        @if(tagType.dataType === TAG_DATA_TYPES.TEXT) {
        <input pInputText class="w-full border rounded-base p-1 border-gray-300" [ngModel]="value"
            (ngModelChange)="setTagValue(tagType._id || '', $event)" [name]="'tag_' + tagType._id"
            [style]="{ outline: 'none' }" />
        }

        @if(tagType.dataType === TAG_DATA_TYPES.NUMBER) {
        <input pInputNumber type="number" class="w-full border rounded-base p-1 border-gray-300" [ngModel]="value"
            (ngModelChange)="setTagValue(tagType._id || '', $event)" [name]="'tag_' + tagType._id"
            [style]="{ outline: 'none' }" />
        }

        @if(tagType.dataType === TAG_DATA_TYPES.DATE) {
        <app-datepicker [ngModel]="value" (ngModelChange)="setTagValue(tagType._id || '', $event)" [config]="{
                    dateFormat: 'dd MM yy',
                    showIcon: true,
                    appendTo: 'body'
                }" />
        }

        @if(tagType.dataType === TAG_DATA_TYPES.DROPDOWN) {
        <app-multi-select [ngModel]="value" (ngModelChange)="setTagValue(tagType._id || '', $event)"
            [options]="getOptionsForTag(tagType._id || '')" [config]="{ appendTo: 'body' }" />

        @if(hasNoOptions(tagType._id || '') && tagType.mandatory) {
        <div class="text-danger text-sm">
            {{ emptyDropdownWarningText }}
            <a href="/settings/tags" class="text-blue-500">here</a>
        </div>
        }
        }
    </div>
</ng-template>
@if(stepperConfig()) {
<app-stepper [config]="stepperConfig()!" [visible]="visible"
    [disableNextButton]="stepperService.currentStepIndex() === 0 && (!isFormValid())"
    [finishButtonLoading]="submitLoading" (stepChange)="onStepChange($event)" (nextStepClick)="onNextStepClick()"
    (previousStepClick)="onPreviousStepClick()" (finish)="onFinish()" (close)="onStepperClose()">

    <!-- Step 0: Create Project -->
    <div *stepperStep="stepperConfig()!.steps[0]">
        <div class="flex-1 min-h-0 overflow-y-auto">
            <ng-container *ngTemplateOutlet="formFields"></ng-container>
        </div>
    </div>

    <!-- Step 1: Add Milestones -->
    <div *stepperStep="stepperConfig()!.steps[1]">
        <div class="flex flex-column max-h-full">
            <app-milestones [milestones]="createProjectMilestones" [showActions]="false" [showHeader]="false"
                [maxMilestoneDueDate]="projectFormData.dueDate" [permissions]="permissions" class="h-full w-full"
                (milestonesChange)="onMilestonesChanged()">
            </app-milestones>
        </div>
    </div>

    <!-- Step 2: Add Team -->
    <div *stepperStep="stepperConfig()!.steps[2]">
        <div class="flex-1 min-h-0 overflow-hidden overflow-y-auto">
            <app-share-to-users [shareDetails]="shareDetails" [projectId]="projectId"
                (changeSharedWithWorkspace)="changeSharedWithWorkspace($event)"
                (changeSharedWithProject)="changeSharedWithProject($event)" [isProject]="true" [mode]="mode"
                [currentUserRole]="currentUserRole" (needAccessUsers)="needAccessUsers = $event"
                (addUserToShare)="onAddMember($event)" (updateSharedUser)="onUpdateMember($event)"
                (removeUserFromShare)="onRemoveMember($event)">
            </app-share-to-users>
        </div>
    </div>
</app-stepper>
}

<!-- Project Knowledge Dialog -->
<app-project-knowledge-dialog [(visible)]="showProjectKnowledgeDialog" [existingFiles]="projectKnowledgeFiles"
    [existingKnowledgeBases]="projectKnowledgeBases" [existingUploadMode]="projectKnowledgeUploadMode"
    (upload)="onProjectKnowledgeUpload($event)">
</app-project-knowledge-dialog>